import clsx from "clsx";
import { ChevronDownIcon } from "lucide-react";
import Link from "next/link";
import { useState } from "react";

import type { INavbarLink } from "./Navbar";
import { useLazyIntercom } from "~/hooks";

interface Props {
	link: INavbarLink;
	toggleSnackbar: () => void;
}

const NavbarSnackbarItem = ({ link, toggleSnackbar }: Props) => {
	const [isOpen, setIsOpen] = useState(false);
	const { preload, show } = useLazyIntercom();

	return (
		<div className="w-full">
			{link.children ? (
				<button
					onClick={() => setIsOpen(!isOpen)}
					className="flex w-full items-center justify-between font-medium text-lg"
				>
					<div className="flex items-center">
						<link.icon size={20} className="mr-2" />

						{link.label}
					</div>

					<ChevronDownIcon
						size={20}
						className={clsx({ "rotate-180": isOpen })}
					/>
				</button>
			) : link.href ? (
				<Link
					href={link.href!}
					onClick={toggleSnackbar}
					target={link.target}
					className="flex w-full items-center font-medium text-lg hover:underline"
				>
					<link.icon size={20} className="mr-2" />
					{link.label}
				</Link>
			) : (
				<button
					onClick={() => {
						toggleSnackbar();
						link.onClick?.();
					}}
					className="flex w-full items-center font-medium text-lg hover:underline"
				>
					<link.icon size={20} className="mr-2" />
					{link.label}
				</button>
			)}

			{link.children && isOpen && (
				<div className="mt-3 ml-2 flex flex-col gap-3.5 border-l pl-4">
					{link.children.map((child) =>
						child.href ? (
							<Link
								href={child.href}
								onClick={toggleSnackbar}
								key={child.label}
								target={child.target}
								className="flex w-full items-center gap-2 whitespace-nowrap font-medium text-base hover:underline"
							>
								<child.icon size={20} />
								{child.label}
							</Link>
						) : child.intercomButton ? (
							<button
								key={child.label}
								onFocus={preload}
								onClick={() => {
									show();
									toggleSnackbar();
								}}
								className={clsx(
									"flex w-full items-center gap-2 whitespace-nowrap font-medium text-base hover:underline",
									child.className,
								)}
							>
								<child.icon size={20} />
								{child.label}
							</button>
						) : (
							<button
								onClick={toggleSnackbar}
								key={child.label}
								className={clsx(
									"flex w-full items-center gap-2 whitespace-nowrap font-medium text-base hover:underline",
									child.className,
								)}
							>
								<child.icon size={20} />
								{child.label}
							</button>
						),
					)}
				</div>
			)}
		</div>
	);
};

export default NavbarSnackbarItem;
